import React, { Fragment } from "react";
import _ from "lodash";

import { TableExpandableCard } from "../../../../../../components/table/components/TableExpandableCard";
import { DeviceNameCellMobile } from "../../../../../../components/table";
import { DeviceWithType } from "../../../../../../components/devices/DeviceWithType";
import { InfectionsSummary } from "../../../infectionsSummary";
import { ClickAbsorber } from "../../../../../../components/clickAbsorber/ClickAbsorber";
import { BlockedDevicesActionsDropdown } from "../blockedDevicesActionsDropdown";

export const TableCard = ({
  isExpanded,
  details,
  manufacturer,
  name,
  identifiers,
  infections,
  logicalDeviceId,
}) => {
  return (
    <TableExpandableCard
      isExpanded={isExpanded}
      content={
        <Fragment>
          <DeviceNameCellMobile name={name} />
          <div>
            {_.map(details, ({ type, identifier }) => (
              <DeviceWithType
                key={identifier}
                type={type}
                identifier={identifier}
              />
            ))}
          </div>
          <InfectionsSummary infections={infections} />
        </Fragment>
      }
      aside={
        <ClickAbsorber>
          <BlockedDevicesActionsDropdown
            device={{ name, identifiers, manufacturer, logicalDeviceId }}
            validateImmediately={false}
            isSavedDevice={true}
          />
        </ClickAbsorber>
      }
    />
  );
};
